import type { PublicationStatus, SkillPoolRollup } from '@/hooks/use-evaluation-rubrics-admin'

/** Rows without `publication_status` predate draft/publish and count as published. */
export function isPublished(item: { publication_status?: PublicationStatus }): boolean {
  return item.publication_status !== 'draft'
}

export function publishedOnly<T extends { publication_status?: PublicationStatus }>(items: T[]): T[] {
  return items.filter(isPublished)
}

/** "12 candidates · Foundational 3, Working 5 · Rank 8 of 120 skills (93rd percentile)", or null without roll-ups. */
export function poolSummary(rollup: SkillPoolRollup): string | null {
  if (typeof rollup.candidate_count !== 'number') return null
  const count = rollup.candidate_count
  const parts = [`${count} ${count === 1 ? 'candidate' : 'candidates'}`]
  const mix = Object.entries(rollup.proficiency_mix ?? {}).filter(([, n]) => n > 0)
  if (mix.length) parts.push(mix.map(([level, n]) => `${level} ${n}`).join(', '))
  if (rollup.pool_rank && rollup.pool_size) {
    const percentile =
      typeof rollup.pool_percentile === 'number' ? ` (${ordinal(Math.round(rollup.pool_percentile))} percentile)` : ''
    parts.push(`Rank ${rollup.pool_rank} of ${rollup.pool_size} skills${percentile}`)
  }
  return parts.join(' · ')
}

function ordinal(n: number): string {
  const tens = n % 100
  if (tens >= 11 && tens <= 13) return `${n}th`
  return `${n}${({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[n % 10] ?? 'th'}`
}
